module.exports = __webpack_public_path__ + "img/slide25.dfa19ea8.png";